<template lang="pug">
div
  v-menu(v-model="showMenu" rounded="lg" allow-overflow :close-on-content-click="false" left offset-y content-class="border-menu" max-height="370")
    template(#activator="{ on, attrs }")
      v-btn.button-sm(color="primary" outlined v-bind="attrs" v-on="on")
        v-icon(left) mdi-plus
        | {{ $t('add_provider') }}
    .text-xs.white
      .menu-header.pt-2
        v-text-field.text-sm.round-xl.mx-4(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider.mt-2
      .px-4.py-3.font-semibold {{ $t('providers_list') }}
      v-divider
      div.d-flex.justify-center.my-6(v-if="isFetching")
        v-progress-circular(:width="2" :size="30" color="primary" indeterminate)
      template(v-else)
        div(v-for="item in filteredItems")
          y-checkbox.mx-4.my-3(v-model="item.check")
            template(#label)
              div.text-sm.neutral700--text {{ item.name }}
          v-divider
        template(v-if="!filteredItems.length")
          .px-4.py-3 No results match
      
      .menu-footer
        div.d-flex.align-center.px-4.py-3
          div.text-xs.font-semibold.underline.normal-case.neutral700--text.clickable(@click="showMenu = false") {{ $t('cancel') }}
          v-spacer
          v-btn.button-xs(color="neutral700" :dark="Boolean(filteredItems.length > 0)" :disabled="filteredItems.length === 0" :loading="isLoading" @click="clickAdd") {{ $t('add') }}

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['selectedProviders'],
  data: () => ({
    searchText: '',
    isFetching: false,
    isLoading: false,
    showMenu: false,
    providers: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    filteredItems() {
      if (this.selectedProviders.length > 0) {
        let providerList = this.providers.filter(f => !this.selectedProviders.map(m => m.id).includes(f.id))
        return providerList
      }
      return this.providers
    }
  },
  watch: {
    showMenu () {
      this.fetchProviders()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchProviders(query) {
      this.isFetching = true
      const params = {
        page_size: -1,
        status: 'active',
        fields: 'id,name,type',
        search: query || ''
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers`, { params })
        .then(resp => {
          if (resp?.data.results) {
            this.providers = resp.data.results
            this.providers.map(m => m.check = false)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    queryChanged: debounce(function () {
      this.fetchProviders(this.searchText)
    }, 750),
    clickAdd () {
      let providers = this.filteredItems.filter(f => f.check)
      this.$emit('added', providers)
      this.showMenu = false
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.menu-header {
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  top: 0;
  position: sticky;
  z-index: 1;
}
.menu-footer {
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  bottom: 0;
  position: sticky;
  z-index: 1;
}
</style>